import React from 'react';

/**
 *  EmailContext is the initial context that passes through all the email components
 *
 */
const emailContext = {
  uiContext: 'default',
  // default, buildAndPrice, wallet, cta, calculator, quote
  listing: {},
  owner: {}
};
const EmailContext = /*#__PURE__*/React.createContext(emailContext);
export default EmailContext;